import { render, staticRenderFns } from "./ThankYouNoFee.vue?vue&type=template&id=d894f624&"
import script from "./ThankYouNoFee.vue?vue&type=script&lang=ts&"
export * from "./ThankYouNoFee.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports